module.exports = new __parcel__URL__("comments.2ff5d6b0.svg").toString();